import styled from 'styled-components';
import { default as MaterialTablePagination } from '@mui/material/TablePagination'; // https://material-ui.com/api/table-pagination/

export const Wrapper = styled.tr`
  width: 100%;
  display: flex;
  align-items: center;
  .MuiTablePagination-root {
    border: none;
  }
  td {
    padding: 0;
  }      
}
`;
export const WrapperLeft = styled.td`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  margin-left: 10px;
`;
export const WrapperRight = styled.td`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const TablePagination = styled(MaterialTablePagination)``;
